const initialState = {
    broadcast_messages: [],
    broadcast_messages_count: 0,
    isReadingBroadcastMessage: false,
    isCreatingBroadcastMessage: false,
    isUpdatingBroadcastMessage: false,
    created_by_users: [],
    isReadingCreatedByUsers: false,
}

export default initialState;
